"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
var rxjs_1 = require("rxjs");
function flatMapFormer(project) {
    return operators_1.flatMap(function (_a) {
        var v1 = _a[0], v2 = _a[1];
        return rxjs_1.zip(project(v1), rxjs_1.of(v2));
    });
}
exports.flatMapFormer = flatMapFormer;
function flatMapLatter(project) {
    return operators_1.flatMap(function (_a) {
        var v1 = _a[0], v2 = _a[1];
        return rxjs_1.zip(rxjs_1.of(v1), project(v2));
    });
}
exports.flatMapLatter = flatMapLatter;
